'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import IconMapMarker from '../../Icons/IconMapMarker';

import { showMapsModal } from '../../../app/Maps/actions';

class MapsLinkButton extends React.Component {
  constructor (props) {
    super(props);

    this.item = this.props.realtyObject;

    this.property = this.item.getProperty();
    this.realtyId = this.property.getId();
    this.dealType = this.item.getDealType();
    this.realtyType = this.item.getRealtyType();
    this.geoLocation = this.property.getGeoLocation();
    this.price = this.item.getPrice();

    this.handleOnClick = this.handleOnClick.bind(this);
  }

  getTitle () {
    const type = this.property.getType();
    const totalArea = this.property.getRoom().getTotalArea();

    const title = [
      type ? type.get('fullName') : null,
      totalArea ? totalArea.getLabel(false) : null,
      this.geoLocation.getShortAddress(),
      this.price.getLabel()
    ];

    return title.filter(Boolean).join(' / ');
  }

  handleOnClick (e) {
    e.preventDefault();
    e.stopPropagation();

    this.props.eventMapModal();

    const point = this.geoLocation.getGeoPoint();

    const realtyObject = new Map({
      realtyId: this.realtyId,
      realtyType: this.realtyType,
      dealType: this.dealType,

      lon: (point && point.get(0)) || null,
      lat: (point && point.get(1)) || null,
      isSuburb: this.geoLocation.isSuburb(),
      similarFilter: this.price.getPercentDeviation(10),
      title: this.getTitle()
    });

    this.props.dispatch(showMapsModal(realtyObject));
  }

  render () {
    return <button
      onClick={this.handleOnClick}
      data-tip data-for='tip-maps'
      className='btn-maps-button'
    >
      <IconMapMarker />
      <span>На карте</span>
    </button>;
  }
}

MapsLinkButton.propTypes = {
  realtyObject: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,

  eventMapModal: PropTypes.func
};

MapsLinkButton.defaultProps = {
  eventMapModal: () => {}
};

export default connect()(MapsLinkButton);



// WEBPACK FOOTER //
// ./src/ui/Maps/Controls/MapsLinkButton.jsx